import { useEffect, useRef } from "react";
import Businessbox from "../components/bussinessblocks";
import Form from "../components/form";
import { useNavigate } from "react-router-dom";

function Contact() {
  const topRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <section
      ref={topRef}
      className=" bg-gradient-to-r from-gray-800 to-gray-900 text-white py-20"
    >
      <div className=" container mx-auto flex flex-col items-center justify-center w-full">
        <div className=" w-[50%] py-4 text-center gap-2">
          <h1 className=" text-5xl font-extrabold mt-20">Contact Us</h1>
          <p className="text-gray-300 my-4">
            Voluptate velit esse cillum dolore eu fugiat nulla pariatur.
            Excepteur sint occaecat cupidatat non proident. Excepteur sint
            occaecat cupidatat non proident cupidatat non proident..
          </p>
          <div className="contact-btns flex justify-center mt-6">
            <a
              onClick={() => {
                navigate("/signup");
              }}
              className=" btn1 cursor-pointer bg-blue-500 text-white px-[50px] py-3 rounded-lg hover:bg-blue-600"
            >
              Get Started
            </a>
            <a
              href="/"
              className=" btn2 bg-transparent border border-gray-400 text-white px-[50px] py-3 rounded-lg hover:border-white hover:text-white"
            >
              Learn More
            </a>
          </div>
        </div>
      </div>

      <section>
        <Form />
      </section>

      <section>
        <Businessbox />
      </section>
    </section>
  );
}
export default Contact;
